import { Component, HostBinding, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-mu-form-section',
  templateUrl: './mu-form-section.component.html',
  styleUrls: ['./mu-form-section.component.sass'],
})
export class MuFormSectionComponent implements OnInit {
  @HostBinding('attr.title') attrTitle = '';
  @Input() gridSizeForm: number;
  @Input() title: string;
  @Input() scrollable: boolean;
  @Input() withAbsoluteButtons: boolean;
  @Input() contentClass = '';
  @HostBinding('class') baseClass = 'mu-full-width';

  constructor() {
    /** */
  }

/* eslint-disable @angular-eslint/no-empty-lifecycle-method */
  ngOnInit(): void {
    /** */
  }
/* eslint-enable @angular-eslint/no-empty-lifecycle-method */
}
